var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonprojet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.95V20.1C15 20.64 14.6889 21 14.2222 21H1.77778C1.31111 21 1 20.64 1 20.1V3.9C1 3.36 1.31111 3 1.77778 3H4.11111",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3H14.25C14.7 3 15 3.44444 15 4.11111V8",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C6 2.53333 6.46667 3 7 3C7.53333 3 8 2.53333 8 2C8 1.46667 7.53333 1 7 1C6.46667 1 6 1.46667 6 2Z",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12 2H11.2C11.68 2 12 2.4 12 3V4C12 4.6 11.68 5 11.2 5H4.8C4.32 5 4 4.6 4 4V3C4 2.4 4.32 2 4.8 2H6.88",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9H13",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H9",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15H9",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4439 16.1022L12 17L12.6983 13.8579L16.8878 8.47132C17.3766 7.84289 18.1446 7.84289 18.6334 8.47132C19.1222 9.09975 19.1222 10.0873 18.6334 10.7157L14.4439 16.1022Z",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonprojet);
export default __webpack_public_path__ + "static/media/Mon projet.ad9572e7f53dd4e2e363a6c3f78191cb.svg";
export { ForwardRef as ReactComponent };